import React, { useState } from 'react'
import Generic from './generic';

export default function useAutoescola() {
    const [autoescolas, setAutoescolas] = useState([]);

    const { GenericGet, loading } = Generic();

    async function getAutoescolas() {
        const response = await GenericGet({ rota: 'autoescola' });
        if (response) {
            setAutoescolas(response.data);
        }
    }

    async function getAutoescola({ id }) {
        const response = await GenericGet({ rota: `autoescola` , caminho: '', pesquisa: `${id}` });
        if (response) {
            //console.log(response.data);
            setAutoescolas(response.data);
        }
    }

    const loadingAutoescolas = loading;

    return { autoescolas, getAutoescolas, getAutoescola, loadingAutoescolas };
}
